var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('event-detail',{attrs:{"detail":_vm.detail,"type":_vm.type,"path-name":"TodayHotStock"}})}
var staticRenderFns = []

export { render, staticRenderFns }